module.exports = __webpack_public_path__ + "assets/img/b4-3.d6f03749.png";